import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Carousel from 'react-material-ui-carousel'

//Importing Components
import style from "./style";

import { Grid, Typography } from "@material-ui/core";
import externalLink from "../../assets/social-icons/external-link.svg";

const useStyles = makeStyles(style);

function Testimonials({data}) {


  var items = data

  return (
    <Carousel style={{width:'100%'}}
         
      navButtonsWrapperProps={{   // Move the buttons to the bottom. Unsetting top here to override default style.
        style: {
              margin: '-1.2rem -0.5rem',
        }
      }} 
      indicatorIconButtonProps={{
        style:{
        color:"#1d222b",
      }
      }}
      activeIndicatorIconButtonProps={{
        style:{
          color:"#5D5FEF"
        }
      }}
      navButtonsAlwaysVisible={false}
      stopAutoPlayOnHover={true}
      interval={5000}
      fullHeightHover={true}
      animation="slide"
    >
      {
        items.map( (item, i) => <Testimonial key={i} item={item} /> )
      }
    </Carousel>
  );
}


function Testimonial({item}) {
  const classes = useStyles();

  return (
    <Grid
      container
      className={`${classes.testimonial}`}
    >
      <Grid className={`${classes.imageContainer}`}>
        <img className={classes.img} src={item.src} alt="Testimonial Authors" data-aos="fade-in" data-aos-delay="100"/>
      </Grid>
      <Grid className={`${classes.textConatainer}`}>
        <Typography variant="h2" data-aos="fade-in" data-aos-delay="100" gutterBottom className={classes.secondaryTitle}>
        {item.name}
        </Typography>
        <Typography variant="h6" data-aos="fade-in" data-aos-delay="200" gutterBottom className={classes.subTitle}>
        {item.role}
        </Typography>
        <Typography variant="h6" data-aos="fade-in" data-aos-delay="300" gutterBottom className={classes.description}>
        {item.text}
        </Typography>
        <a href={item.link} target="_blank" rel="noreferrer">
        <Typography variant="h6" data-aos="fade-in" data-aos-delay="300" gutterBottom className={`${classes.link} hover-detect`}>
          Check it out LinkedIn
          <img width={16} height={16} src={externalLink}/>
        </Typography>
        </a>
      </Grid>
    </Grid>
  )
}

export default Testimonials;
